import { IAppState } from '../../../AppModulesWrapper';

import { ITotalAmount } from '../../types/reducers/checkoutInfo';

export function selectTotalAmount(state: IAppState): ITotalAmount {
  return state.servicePickerWidget.checkoutInfo.totalAmount;
}
